import { call, put, takeEvery } from 'redux-saga/effects';
import { 
  deleteBookmarkRequest, 
  deleteBookmarkSuccess, 
  deleteBookmarkFailure 
} from '../slice/deleteBookmarkSlice';
import { deleteBookmarkApi } from '../../api/apiService';

// Worker saga
export function* handleDeleteBookmark(action: { payload: { bookmarkId: string } }): Generator<any, void, any> {
  try {
    const response = yield call(deleteBookmarkApi as any, action.payload.bookmarkId);

    if (response && response.data.success) {
      yield put(deleteBookmarkSuccess());
    } else {
      yield put(deleteBookmarkFailure('Unexpected response from server'));
    }
  } catch (err: any) {
    const safeError = err instanceof Error ? err : new Error(String(err));
    console.error("Delete Bookmark Error:", safeError.stack);
    yield put(deleteBookmarkFailure(safeError.message || 'An unknown error occurred.'));
  }
}


// Watcher saga
export function* deleteBookmarkSaga() {
  yield takeEvery(deleteBookmarkRequest, handleDeleteBookmark);
}
